import { useMemo } from 'react';
import {
  getApplicationProps,
  getCreditAndCriminalProps,
  getDocumentationProps,
} from './hooks.useManageProps.utils';

const useManageProps = ({
  allFilteredMembersDocumentationCompleted,
  allMembersHaveCompletedDocumentation,
  allSectionsEnabled,
  applicationSectionProgress,
  creditAndCriminalSectionProgress,
  documentationSectionProgress,
  isStudentDisqualified,
  isUnInvitedSecondaryUser,
  screeningStatus,
}) => {
  return useMemo(() => {
    const allMembersHavePassedScreening = [
      'Approved with Conditions',
      'Approved',
    ].includes(screeningStatus);

    const creditAndCriminalScreeningIneligible =
      screeningStatus?.length && screeningStatus === 'Declined';

    const userIsIneligible =
      isStudentDisqualified || creditAndCriminalScreeningIneligible;

    const isAwaitingDocumentation =
      allFilteredMembersDocumentationCompleted &&
      !allMembersHaveCompletedDocumentation;

    const applicationProps = getApplicationProps({
      applicationSectionProgress,
      isUnInvitedSecondaryUser,
      userIsIneligible,
    });

    const creditAndCriminalProps = getCreditAndCriminalProps({
      allMembersHavePassedScreening,
      allSectionsEnabled,
      applicationProps,
      creditAndCriminalScreeningIneligible,
      creditAndCriminalSectionProgress,
      isUnInvitedSecondaryUser,
      userIsIneligible,
    });

    const documentationProps = getDocumentationProps({
      allMembersHaveCompletedDocumentation,
      allSectionsEnabled,
      creditAndCriminalProps,
      documentationSectionProgress,
      isAwaitingDocumentation,
      isUnInvitedSecondaryUser,
      userIsIneligible,
    });

    return {
      applicationProps,
      creditAndCriminalProps,
      documentationProps,
    };
  }, [
    allFilteredMembersDocumentationCompleted,
    allMembersHaveCompletedDocumentation,
    allSectionsEnabled,
    applicationSectionProgress,
    creditAndCriminalSectionProgress,
    documentationSectionProgress,
    isStudentDisqualified,
    isUnInvitedSecondaryUser,
    screeningStatus,
  ]);
};

export default useManageProps;
